
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('overview', {
      data: 'trafficpersqm'
    })
  } // computed
}; // export default
